import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, saveSession } from "@/lib/api";
import Navbar from "@/components/karmivo/Navbar";
import { Building2 } from "lucide-react";

export default function FranchiseLogin() {
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/auth/login`, { phone, password, role: "franchise_admin" });
      saveSession("franchise_admin", data); toast.success("Welcome"); nav("/franchise/dashboard");
    } catch (e) { toast.error(e.response?.data?.detail || "Login failed"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50"><Navbar/>
      <div className="max-w-md mx-auto px-6 py-16">
        <Card className="p-6">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-orange-500 text-white rounded-xl flex items-center justify-center"><Building2 size={18}/></div>
            <div><h1 className="font-display text-xl font-bold">Franchise Login</h1><p className="text-xs text-slate-500">Access your franchise operations</p></div>
          </div>
          <div className="space-y-3">
            <div><Label>Phone</Label><Input value={phone} onChange={e => setPhone(e.target.value)} data-testid="fl-phone"/></div>
            <div><Label>Password</Label><Input type="password" value={password} onChange={e => setPassword(e.target.value)} data-testid="fl-password"/></div>
            <Button className="w-full bg-orange-500 hover:bg-orange-600" onClick={submit} disabled={loading} data-testid="fl-submit">Login</Button>
            <p className="text-xs text-slate-500 text-center">New partner? <Link to="/franchise/apply" className="text-orange-600 font-semibold" data-testid="fl-apply-link">Apply</Link></p>
          </div>
        </Card>
      </div>
    </div>
  );
}
